import { createMuiTheme } from '@material-ui/core/styles'

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
    fontSize: 16,
    h3: {
      fontSize: 12,
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: 2,
      color: 'rgba(0, 0, 0)',
      textTransform: 'uppercase',
    },
    caption: {
      color: 'rgba(0, 0, 0)',
      fontWeight: 500,
      fontSize: 10,
      lineHeight: 1.6,
      letterSpacing: 2.5,
      textTransform: 'uppercase',
    },
    captionNext: {
      color: 'rgba(0, 0, 0)',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: 'normal',
    },
    h5: {
      fontSize: 18,
      lineHeight: 1.8,
      color: 'rgb(0, 0, 0)',
    },
    h6: {
      fontSize: 18,
      fontWeight: 600,
      lineHeight: 1.5,
      color: 'rgba(0, 0, 0)',
    },
    body1: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 1.5,
      color: 'rgba(0, 0, 0)',
    },
    body2: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 1.5,
      color: 'rgba(0, 0, 0)',
    },
    subtitle1: {
      fontSize: 12,
      fontWeight: 400,
      lineHeight: 1.5,
      color: 'rgba(0, 0, 0, .75)',
    },
    overline: {
      fontSize: 8,
      fontWeight: 600,
      lineHeight: 2,
      color: 'rgba(0, 0, 0, .5)',
      letterSpacing: 2,
      textTransform: 'uppercase',
    },
  },
  palette: {
    primary: {
      dark: '#ffbf00',
      main: '#ffcc00',
      contrastText: '#000',
    },
    secondary: {
      main: '#8866ff',
      contrastText: '#fff',
    },
    background: {
      default: '#fff',
    },
  },
  shadows: [
    'none',
    '0 1px 4px 0 rgba(0, 0, 0, 0.1)',
    '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    '0 33px 100px 0 rgba(0, 0, 0, 0.1)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
    '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
    '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
    '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
    '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
    '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
    '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
    '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
    '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
    '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
    '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
    '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
    '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
    '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
    '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
    '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
  ],
  shape: {
    borderRadius: 4,
  },
})

export default theme
